import {
	AddFlatChargeTypeMutation,
	DeactivateFlatChargeTypeMutation,
	ReactivateFlatChargeTypeMutation,
	UpdateFlatChargeTypeMutation
} from "~/gql/mutations/flatChargeType.generated";
import { GetFlatChargeTypesQuery } from "~/gql/queries/flatChargeType.generated";

export const flatChargeTypeEndpoints = {
	AddFlatChargeType: {
		invalidatesTags: ["FlatChargeTypes"] as AddTagTypes,
		transformResponse: (res: AddFlatChargeTypeMutation) => res
	},
	DeactivateFlatChargeType: {
		invalidatesTags: ["FlatChargeTypes"] as AddTagTypes,
		transformResponse: (res: DeactivateFlatChargeTypeMutation) => res
	},
	GetFlatChargeTypes: {
		providesTags: ["FlatChargeTypes"] as AddTagTypes,
		transformResponse: (res: GetFlatChargeTypesQuery) => res
	},
	ReactivateFlatChargeType: {
		invalidatesTags: ["FlatChargeTypes"] as AddTagTypes,
		transformResponse: (res: ReactivateFlatChargeTypeMutation) => res
	},
	UpdateFlatChargeType: {
		invalidatesTags: ["FlatChargeTypes"] as AddTagTypes,
		transformResponse: (res: UpdateFlatChargeTypeMutation) => res
	}
};
